import __request__ from "routing/request";
export function listStatuses(sort = "category", page = 1, per_page = 15, query, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.asset/assets/categories", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(Category, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.asset/assets/categories", Category, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.asset/assets/categories/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInUse(asset_type, query, page = 1, per_page = 10, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.asset/assets/categories/in_use", null, { "asset_type": asset_type, "query": query, "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, Category, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.asset/assets/categories/${id}`, Category, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.asset/assets/categories/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
